import {Tabs} from "antd";
import {forwardRef, useEffect, useImperativeHandle, useMemo, useRef} from "react";
import {useSetState} from "ahooks";
import {queryClueDispatchFlag} from "@/services/callCenter";
import {ChooseList} from "@/pages/clueManage/clueDetail/components/Modals/DispatchDesignDept/list.tsx";

const DesignDeptMnr = forwardRef((props: any, ref) => {
  const {clueId} = props;
  const listRef = useRef()
  const submitObj = useRef({})
  const [state, setState] = useSetState({
    data: [],
    resourceObj: {},
    activeKey: '',
    loading: false,
  })

  useEffect(() => {
    getTabs()
  }, []);

  const getTabs = () => {
    queryClueDispatchFlag(clueId).then(res => {
      const data = res?.filter(item => !item.dispatchFlag)
      const resourceObj = {}
      const result = data.map(item => {
        resourceObj[item.bizType] = item
        return {
          ...item,
          label: item.bizTypeName,
          key: item.bizType,
        }
      })
      setState({data: result, resourceObj, activeKey: data[0]?.key})
    })
  }

  const onGetSubmitData = () => {
    const obj = {...submitObj.current}
    const relatives = []
    Object.keys(obj).forEach(key => {
      const item = {
        bizType: key,
        salesTemplateNodeId: state.resourceObj[key]?.salesTemplateNodeId,
        salesTemplateId: state.resourceObj[key]?.salesTemplateId,
        autoAssignFlag: state.resourceObj[key]?.autoAssignFlag,
        relatives: obj[key]?.[0] ? {
          name: obj[key][0]?.userName,
          ucenterUserId: obj[key][0]?.ucenterUserId,
          deptId: obj[key][0]?.orgId,
          roleCode: obj[key][0]?.roleCode,
          companyId: obj[key][0]?.companyId,
        } : {},
      }
      relatives.push(item)
    })
    return relatives
  }

  const onChangeTabKey = (key) => {
    setState({activeKey: key})
  }

  useImperativeHandle(ref, () => {
    return {
      getData: () => onGetSubmitData(),
    }
  }, [])

  const tabs = useMemo(() => {
    return state.data.map(item => {
      const selectedRows = submitObj.current[item.bizType]
      return {
        ...item,
        children: item.message ? <strong>{item.message}</strong> :
            <ChooseList key={item.bizType}
                        fetchApi={props.fetchApi}
                        updateSelectedObj={(rows) => { submitObj.current[item.bizType] =  rows }}
                        rows={selectedRows}
                        id={state.resourceObj[state.activeKey]?.salesTemplateNodeId}
                        ref={listRef}
                        editId={clueId}/>
      }
    })
  }, [state.data, submitObj.current])

  return <Tabs items={tabs} activeKey={state.activeKey} onChange={onChangeTabKey}/>
})

export default DesignDeptMnr